"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const SiteText_1 = require("../lib/SiteText");
const siteText = vue_1.default.extend({
    methods: {
        getSiteText(siteTextKey, ...replacements) {
            const store = this.$store;
            const siteTextMap = store.getters.siteTextMap || {};
            const debug = store.getters.debugSiteText || false;
            return (0, SiteText_1.getSiteTextItem)(siteTextKey, {
                debug,
                replacements,
                siteTextMap,
            });
        },
    },
});
exports.default = siteText;
